import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const GalaxySwirlAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for(let i=0; i<60; i++){
    const p = (progress + i/60) % 1;
    const ang = p * Math.PI * 12 + i;
    const dst = e.maxRadius * (1 + p * 0.5);
    const r = getRadiusAtAngle(ang, e, dst);
    ctx.beginPath(); ctx.arc(e.pos.x + Math.cos(ang)*r, e.pos.y + Math.sin(ang)*r, 3*(1-p), 0, Math.PI*2); ctx.fill();
  }
};

registerBlastAnimation('GALAXY_SWIRL', GalaxySwirlAnimation);
